
<template>
<div>
    <modal v-model="modalInvoice" dir="right" :modalClass="['fill', 'lg right h100']" :title="modalInvoice && modalInvoice.title? modalInvoice.title : `Nueva ${modalInvoice && modalInvoice.is_invoice? 'Factura' : 'Boleta'} de Proveedor`">
        <div class="section" v-if="modalInvoice">
            <div class="hdvm mb15">
                <div class="">               
                    <div class="bold">Proveedor</div>
                    <div class="">{{`${modalInvoice.provider.name} ${modalInvoice.provider.has_rut ? Util.Rut(modalInvoice.provider.rut):''}`}}</div>
                </div>
                <input-select class="" label="Tipo" v-model="modalInvoice.is_invoice" :items="[{text:'Factura', value : 1}, {text:'Boleta', value : 0}]"></input-select>
            </div>
            
            <div class="hs mb15">
                <input-field v-model="modalInvoice.number" label="Número" type="int+"></input-field>
                <input-date v-model="modalInvoice.date" label="Fecha" type="DATE" format="timestamp"></input-date>
            </div>
        
            <div class="separator mb20 mt20"></div>

            <div>
                <input-field class="mb15"
                v-model="modalInvoice.discount" 
                label="Descuento" 
                type="float" 
                placeholder="(Opcional)"
                :prefix="modalInvoice.discount < 0 ? '$' : ''"
                :suffix="modalInvoice.discount > 0 ? '%' : ''"
                info="Un número negativo representa un valor fijo en pesos y un número positivo un porcentaje de descuento sobre el monto neto">
                </input-field>
                
                <div class="separator mb20 mt20"></div>
            </div>

            <div class="flex align-center mb20">
                <div class="f18 flex-fill flex">Items <span class="counter">{{modalInvoice.inventory.length}}</span></div>
                <i class="options icon-search" title="Buscar factura anterior" @click="OpenLastInvoices"></i>
                <i class="options icon-plus" @click="modalProviderItem = {item: '', quantity: 0, price: 0, total_price: 0, discount: 0, tax: 0, delivery_fee: 0, iva: true}"></i>
            </div>
            <div class="secondary-text mt10 ta-center" v-if="!modalInvoice.inventory.length">No hay items</div>
            <div class="flex well selectable mb10" v-for="(entry, index) in modalInvoice.inventory" :key="index" @click="EditItemProvider(entry, index)">
                <div class="flex-fill">
                    <div class="bold">{{entry.item}}</div>
                    <div class="flex">
                        <div class="w20">
                            <div class="secondary-text">Cantidad</div>
                            <div>{{Util.Number(entry.quantity)}}</div>
                        </div>
                        <div class="w20">
                            <div class="secondary-text">Costo Unitario</div>
                            <div>${{Util.Number(entry.price)}}</div>
                        </div>
                        <div class="w10">
                            <div class="secondary-text">IVA</div>
                            <i v-if="entry.iva" class="icon icon-check cpurple"></i>
                        </div>
                        <div class="w20">
                            <div class="secondary-text">Impuesto</div>
                            <div v-if="!entry.tax">-</div>
                            <div v-else-if="entry.tax > 0">{{Util.Number(entry.tax)}}%</div>
                            <div v-else>{{Util.Price(entry.tax)}}</div>
                        </div>
                        <div class="w20">
                            <div class="secondary-text">Flete Neto</div>
                            <div v-if="!entry.delivery_fee">-</div>
                            <div v-else-if="entry.delivery_fee > 0">{{Util.Number(entry.delivery_fee)}}%</div>
                            <div v-else>{{Util.Price(entry.delivery_fee)}}</div>
                        </div>
                        <div class="w20">
                            <div class="secondary-text">Descuento</div>
                            <template v-if="DiscountValue(entry)">
                                <div v-if="DiscountValue(entry) > 0">
                                    {{ Util.Number(DiscountValue(entry)) }}%
                                </div>
                                <div v-else>
                                    {{ Util.Price(DiscountValue(entry)) }}
                                </div>
                            </template>
                            <div v-else>-</div>
                        </div>
                    </div>
                </div>
                <i class="options icon-trash" @click.stop="modalInvoice.inventory.splice(index, 1)"></i>
            </div>
        
            <div class="separator mb20 mt20"></div>

            <div class="f18 mb20">Total</div>

            <div class="flex mb15">
                <div class="mr20">
                    <div class="bold">Monto neto</div>
                    <div>{{Util.Price(invoice ? invoice.total.subtotal : 0)}}</div>
                </div>

                <div class="mr20">
                    <div class="bold">Descuento Global</div>
                    <div>{{Util.Price(invoice ? invoice.total.discountGlobal : 0)}}</div>
                </div>

                <div class="ml20">
                    <div class="bold">I.V.A. 19%</div>
                    <div>{{Util.Price(invoice ? invoice.total.iva : 0)}}</div>
                </div>
            </div>

            <div class="flex mb15">
                <div class="mr20">
                    <div class="bold">Impuesto Adicional</div>
                    <div>{{Util.Price(invoice ? invoice.total.taxes : 0)}}</div>
                </div>

                <div class="ml20 mr20">
                    <div class="bold">Flete Neto</div>
                    <div>{{Util.Price(invoice ? invoice.total.deliveryFee : 0)}}</div>
                </div>

                <div class="ml20">
                    <div class="bold">Descuentos</div>
                    <div>{{Util.Price(invoice ? invoice.total.discount : 0)}}</div>
                </div>
            </div>

            <div class="mb15">
                <div class="bold">Total</div>
                <div>{{Util.Price(invoice ? invoice.total.total : 0)}}</div>
            </div>
            
            <label class="">
                <input type="checkbox" v-model="modalInvoice.pending"> Pago pendiente <div class="checkmark"></div>
            </label>

            <input-select class="mt15" label="Método de Pago" v-model="modalInvoice.pay_method" :items="payMethods" v-show="!modalInvoice.pending"></input-select>

            <input-field v-model="modalInvoice.comment" label="Comentario" :lines="3" column placeholder="(Opcional)" class="mt15"></input-field>
            
            <input-files v-model="modalInvoice.files" label="Documentos Adjuntos" class="mt15"></input-files>
            

        </div>

        <label slot="actions" v-if="canExpenseTurn && modalInvoice" style="flex: auto">
            <input type="checkbox" v-model="modalInvoice.expense_turn"> Descontar de caja<div class="checkmark"></div>
        </label>
        <button v-if="modalInvoice && modalInvoice.title" slot="actions" class="primary purple" @click="EditInvoice()">Editar</button>
        
        <button v-else slot="actions" class="primary purple" @click="SaveInvoice()">Guardar</button>
    </modal>

    <modal v-model="modalLastInvoices" title="Documentos anteriores" dir="right" :modalClass="['fill borderless', 'sm right h100']" hideActions>
        <div class="section" v-if="modalLastInvoices">
            <div class="entry selectable" v-for="invoice in modalLastInvoices.invoices" :key="invoice.id" @click="LoadPreviousInvoice(invoice)">
                <div class="fill flex column">
                    <div class="flex">
                        <div class="bold flex-fill">{{invoice.is_invoice ? 'Factura' : 'Boleta'}} de {{ invoice.type == 'FACTURA_EXPENSES' ? 'Gastos' : 'Inventario'}} N°{{invoice.number}}</div>
                        <div>{{Util.Date(invoice.date)}}</div>
                    </div>
                    
                    <div v-for="(item, index) in invoice.data" :key="index" class="flex secondary-text">
                        <div class="bold flex-fill">{{item.item}}</div>
                        <div>{{Util.Number(item.quantity)}} <span>{{item.unit}}</span></div>
                    </div>
                    
                </div>
            </div>
        </div>
    </modal>

    <modal v-model="modalProviderItem" dir="right" :modalClass="['fill', 'sm right h100']" :title="modalProviderItem && modalProviderItem.index >= 0 ? 'Editar Item' : 'Agregar Item'">

        <div class="pa20" v-if="modalProviderItem">

            <input-select class="mb15"
            v-model="modalProviderItem.item" 
            :items="invoiceItemsSelector"
            label="Item"
            canType>
            </input-select>

            <input-field class="mb15"
            v-model="modalProviderItem.quantity"
            type="float+" 
            label="Cantidad"
            :suffix="view == 'INVENTORY' && inventory[modalProviderItem.item] && inventory[modalProviderItem.item].unit ? ' '+inventory[modalProviderItem.item].unit : ''"
            @OnChangeFocused="QuantityChanged($event, modalProviderItem, true)">
            
            </input-field>

            <div class="hdvm mb15">

                <input-field
                v-model="modalProviderItem.price" 
                type="float+" 
                :label="`Costo Unitario Neto`"
                prefix="$"
                @OnChangeFocused="UnitCostChanged($event, modalProviderItem, true)">
                </input-field>

                <input-field
                v-model="modalProviderItem.total_price" 
                type="float+" 
                :label="`Costo Total Neto`"
                prefix="$"
                @OnChangeFocused="CostChanged($event, modalProviderItem, true)">
                </input-field>

            </div>

            <div class="mb15">
                <label>
                    <input class="mt10" type="checkbox" v-model="modalProviderItem.iva">
                    <div class="bold">IVA</div>
                    <div class="checkmark"></div>
                </label>
            </div>
                        
            <input-field class="mb15"
            v-model="modalProviderItem.tax" 
            label="Impuesto Adicional" 
            type="float" 
            placeholder="(Opcional)"
            :prefix="modalProviderItem.tax < 0 ? '$' : ''"
            :suffix="modalProviderItem.tax > 0 ? '%' : ''"
            info="Un número negativo representa un valor fijo en pesos y un número positivo un porcentaje sobre el costo total del item">
            </input-field>

            <input-field class="mb15"
            v-model="modalProviderItem.delivery_fee" 
            label="Flete Neto" 
            type="float" 
            placeholder="(Opcional)"
            :prefix="modalProviderItem.delivery_fee < 0 ? '$' : ''"
            :suffix="modalProviderItem.delivery_fee > 0 ? '%' : ''"
            info="Un número negativo representa un valor fijo en pesos y un número positivo un porcentaje sobre el costo total del item">
            </input-field>

            <input-field 
            v-model="modalProviderItem.discount" 
            label="Descuento" 
            type="float" 
            placeholder="(Opcional)"
            :prefix="modalProviderItem.discount < 0 ? '$' : ''"
            :suffix="modalProviderItem.discount > 0 ? '%' : ''"
            info="Un número negativo representa un valor fijo en pesos y un número positivo un porcentaje sobre el costo total del item">
            </input-field>
                
            
            <!--Util.Price(modalProviderItem.quantity * modalProviderItem.price)-->
                    
            <!--<i class="options icon-trash" title="Quitar ítem" @click="modalInvoice.inventory.splice(index, 1)"></i>-->

        </div>

        
        <button slot="actions" class="primary purple" @click="AddInventoryItemToInvoice">{{modalProviderItem && modalProviderItem.index >= 0 ? 'Editar' : 'Agregar'}}</button>

    </modal>
</div>
</template>

<script>
    export default {
        props: {
            view: {
                type: String,
                default: 'INVENTORY'
            },
        },
        data() {
            return {
                modalInvoice: null,
                modalLastInvoices  : null,
                modalProviderItem: null,
                // invoiceItemsSelector : null,
                inventory : null,
                expenses : null,
                payMethods: [{text: 'Sin definir', value: 'UNDEFINED'}],
                from : null
            }
        },
        methods: {
        QuantityChanged(quantity, modal, isProvider){

            quantity = parseFloat(quantity);
            if(isNaN(quantity) || quantity == 0) return;

            var unitCost = parseFloat(modal[isProvider ? 'price' : 'unit_cost']);

            if(!isNaN(unitCost))
            {
                this.$set(modal, isProvider ? 'total_price' : 'cost', unitCost*quantity);
                return;
            }

            var totalCost = parseFloat(modal[isProvider ? 'total_price' : 'cost']);
            if(!isNaN(totalCost))
            {
                this.$set(modal, isProvider ? 'price' : 'unit_cost', totalCost / quantity);
                return;
            }
            
        },
        UnitCostChanged(unitCost, modal, isProvider)
        {
            var quantity = parseFloat(modal[isProvider ? 'quantity' : 'add']);

            if(isNaN(quantity)) return;
            unitCost = parseFloat(unitCost);
            if(isNaN(unitCost)) return this.$set(modal, isProvider ? 'total_price' : 'cost', '');
            this.$set(modal, isProvider ? 'total_price' : 'cost', unitCost * quantity);

        },
        CostChanged(cost, modal, isProvider)
        {
            var quantity = parseFloat(modal[isProvider ? 'quantity' : 'add']);
            if(isNaN(quantity) || quantity == 0) return;
            cost = parseFloat(cost);
            if(isNaN(cost)) return this.$set(modal, isProvider ? 'price' : 'unit_cost', '');
            if(!isProvider && modal.unit_cost && this.Auth.role == 'cashier' && !this.Auth.restrictions.can_edit_cost_unit) return this.$set(modal, 'add', cost / modal.unit_cost);
            this.$set(modal, isProvider ? 'price' : 'unit_cost', cost / quantity);
        },
        SaveInvoice()
        {
            if(!this.modalInvoice.number) return this.Info('Falta un número de factura');
            if(this.Auth.restrictions && this.Auth.restrictions.required_payment_methods && this.modalInvoice.pay_method == 'UNDEFINED' && !this.modalInvoice.pending) return this.Info('Debe seleccionar un método de pago.');
            if(!this.invoice) return this.Info('Falta el información de un item');

            this.Loading();
            axios.put(`/provider/invoice/${this.Local.id}`, this.invoice).then(res => {
                if(this.view == 'INVENTORY') this.$emit('UpdateInventory');
                if(this.view == 'EXPENSES') this.$emit('LoadInExpense');
                this.Response(res);
                this.$emit('ProviderStats');
                this.$emit('LoadProviders');
                this.$emit('LoadProviderInvoices');

                this.Confirm({
                    title: `¿Imprimir voucher de ${this.invoice.is_invoice ? 'factura' : 'boleta'} de proovedor de ${this.view == 'INVENTORY' ? 'inventario' : 'gasto'}?`,
                    text: 'Imprimir',
                    class: 'selected-color',
                    function: () => {this.$emit('PrintInvoice',res.data)}
                });
                this.modalInvoice = null;
            }).catch(err => {
                this.Response(err);
            });

        },
        EditInvoice(){
            if(!this.modalInvoice) return this.Info('Error, ha ocurrido un problema.');
            if(!this.modalInvoice.id) return this.Info('No se ha seleccionado ninguna factura');
            if(!this.modalInvoice.number) return this.Info('Falta un número de factura');
            if(!this.invoice) return this.Info('Falta el información de un item');
            if(this.Auth.restrictions && this.Auth.restrictions.required_payment_methods && this.modalInvoice.pay_method == 'UNDEFINED' && !this.modalInvoice.pending) return this.Info('Debe seleccionar un método de pago.');

            this.Loading();
            this.$set(this.invoice, 'view', this.view);
            axios.patch(`/providers/invoice/${this.modalInvoice.id}/${this.Local.id}`, this.invoice).then(res => {
                this.Response(res);
                this.$emit('LoadProviders');
                // this.modalProviderStats.history.length = 0;
                this.$emit('ProviderStats');
                this.$emit('LoadProviderInvoices');
                if(this.view == 'INVENTORY') this.$emit('UpdateInventory');
                if(this.view == 'EXPENSES') this.$emit('LoadInExpense');
                if(this.from == 'turn') this.$emit('OnLoadTurn');
                if(this.from == 'pendingPayments') this.$emit('OnInvoiceUpdated');

                this.Confirm({
                    title: `¿Imprimir voucher de ${this.invoice.is_invoice ? 'factura' : 'boleta'} de proovedor de ${this.view == 'INVENTORY' ? 'inventario' : 'gasto'}?`,
                    text: 'Imprimir',
                    class: 'selected-color',
                    function: () => {this.$emit('PrintInvoice',res.data)}
                });
                this.modalInvoice = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        DeleteInvoice(){
            // this.$set(this.modalProviderStats, 'history', []); 
            this.$emit('LoadProviderInvoices');
            if(this.from == 'turn') this.$emit('OnLoadTurn');
        },
        async ModalEditInvoice(invoice, from){
            this.from = from;
            if(this.view == 'INVENTORY' && !this.inventory) await this.LoadInventory();
            else if(this.view == 'EXPENSES' && !this.expenses) await this.LoadExpenses();
            
            this.modalInvoice = Util.Copy(invoice, 
            {
                title: `Editar ${invoice.is_invoice ? 'Factura' : 'Boleta'} de Proveedor`,
                provider: invoice.custom_data.provider,
                inventory : invoice.data,
                pending: invoice.paid_at? false : true,
                comment: invoice.custom_data.comment,
                files: invoice.custom_data.files,
                view : this.view,
                is_invoice : invoice.is_invoice,
                expense_turn : invoice.expense_turn
            });
            

        },
        OpenLastInvoices() {
            this.Loading();
            axios.get(`/provider/${this.Local.id}/invoices/${this.modalInvoice.provider.rut}?view=${this.view}`).then(res => {
                if(!res.data.length) return this.Info(`No hay facturas de este proveedor`);
                this.Response(res);
                this.modalLastInvoices = {
                    invoices: res.data
                };
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadPreviousInvoice(invoice)
        {
            var inventory = [];

            invoice.data.forEach(item => {
                let condition = this.view == 'INVENTORY'? this.inventory[item.item] : this.invoiceItemsSelector.some(data => data.text == item.item);
                // if(this.inventory[item.item])
                if(condition)
                {
                    inventory.push({
                        item: item.item,
                        quantity: item.quantity,
                        price: item.price,
                        tax: item.taxPercentage,
                        discount: item.discountPercentage,
                        delivery_fee: item.deliveryFeePercentage,
                        iva: item.ivaPercentage !== 0
                    });
                }

                this.$set(this.modalInvoice, 'inventory', inventory);
            });

            this.modalLastInvoices = null;
        },
        EditItemProvider(data, index) {

            let item = Util.Copy(data);
            this.modalProviderItem = {
                item : item.item,
                quantity : item.quantity,
                price : item.price,
                total_price : item.quantity * item.price,
                discount : item.discountPercentage ? item.discountPercentage : item.discount,
                tax : item.taxPercentage ? item.taxPercentage : item.taxPercentage,
                delivery_fee : item.deliveryFeePercentage ? item.deliveryFeePercentage : item.deliveryFee,
                iva : item.iva,
                index : index
            }

        },
        AddInventoryItemToInvoice()
        {
            
            if(!this.modalProviderItem.item) return this.Info('Item inválido');
            if(isNaN(this.modalProviderItem.quantity) || this.modalProviderItem.quantity <= 0) return this.Info('Cantidad inválida');
            if(isNaN(this.modalProviderItem.price) || this.modalProviderItem.price <= 0) return this.Info('Precio inválido');

            this.modalProviderItem.item = this.modalProviderItem.item.toUpperCase();

            var index = this.modalProviderItem.index;
            delete this.modalProviderItem.index;

            if(isNaN(index)) this.modalInvoice.inventory.push(this.modalProviderItem);
            else this.$set(this.modalInvoice.inventory, index, this.modalProviderItem);
            
            this.modalProviderItem = null;
        },
        async LoadInventory() {
            this.Loading();
            await axios.get(`/inventory/${this.Local.id}`).then(res => {
                this.inventory = this.Util.CalculateInventoryComposite(res.data.items);
                for(var i = 0; i < res.data.methods.length; i++)
                    this.payMethods.push({text: this.Util.PayMethod(res.data.methods[i]), value: res.data.methods[i]});
                this.Response(res);
            }).catch(err => {
                this.Response(err);
            });
        },
        async LoadExpenses()
        {
            this.Loading();
            await axios.get(`/expenses/${this.Local.id}`).then(res => {
                this.expenses = res.data.types;
                for(var i = 0; i < res.data.pay_methods.length; i++)
                    this.payMethods.push({text: res.data.pay_methods[i] == 'CASH' ? 'Efectivo' : res.data.pay_methods[i], value: res.data.pay_methods[i]});
                this.Response(res);
            }).catch(err => {
                this.Response(err);
            });
        },
        DiscountValue(entry) {
            if (entry.discountPercentage) return entry.discountPercentage;
            return entry.discount;
        }
        },
        computed : {
            invoice() {
                if(!this.modalInvoice) return null;
                if(!this.modalInvoice.inventory.length) return null;

                var items = [];
                var subtotal = 0;
                var iva = 0;
                var taxes = 0;
                var discount = 0;
                var deliveryFeeNet = 0;

                for(var i = 0; i < this.modalInvoice.inventory.length; i++)
                {
                    var item = this.modalInvoice.inventory[i];
                    if(item.quantity <= 0 || item.price <= 0) return null;
                    var itemQuantity = item.quantity;
                    var itemPrice = item.price;
                    var itemTotal = item.quantity * item.price;

                    var itemDiscount = 0;
                    var realDiscount = item.discountPercentage ? item.discountPercentage : item.discount;
                    var itemDiscountPercentage = isNaN(realDiscount) ? 0 : realDiscount;
                    console.log("discoutn percen", itemDiscountPercentage);
                    
                    if(itemDiscountPercentage >= 0)
                        itemDiscount = (itemDiscountPercentage / 100) * itemTotal;
                    else
                        itemDiscount = -itemDiscountPercentage;    
                    discount += itemDiscount;

                    subtotal += itemTotal;
                    itemTotal -= itemDiscount;

                    var itemTax = 0;
                    var itemTaxPercentage = isNaN(item.tax) ? 0 : item.tax;
                    if(itemTaxPercentage >= 0) 
                        itemTax = (itemTaxPercentage / 100) * itemTotal;
                    else
                        itemTax = -itemTaxPercentage;
                    taxes += itemTax;
                    
                    var itemIVA = 0;
                    if(item.iva)
                        itemIVA = 0.19 * itemTotal;


                    var itemDeliveryFeeNet = 0;
                    var itemDeliveryFeePercentage = isNaN(item.delivery_fee) ? 0 : item.delivery_fee;
                    if(itemDeliveryFeePercentage >= 0)
                        itemDeliveryFeeNet = (itemDeliveryFeePercentage / 100) * itemTotal;
                    else
                        itemDeliveryFeeNet = -itemDeliveryFeePercentage;

                    let itemDeliveryFeeGross = itemDeliveryFeeNet * 0.19;
                    deliveryFeeNet += itemDeliveryFeeNet;

                    itemIVA += itemDeliveryFeeGross;
                    iva += itemIVA;
                    
                    var entryTotal = itemTotal + itemIVA + itemTax + itemDeliveryFeeNet;
                    if(entryTotal < 0) return null;
                    items.push({
                        item: item.item,
                        quantity: itemQuantity,
                        price: itemPrice,
                        tax: itemTax,
                        taxPercentage: itemTaxPercentage,
                        iva: itemIVA,
                        ivaPercentage: item.iva ? 19 : 0,
                        discount: itemDiscount,
                        discountPercentage: itemDiscountPercentage,
                        deliveryFee: itemDeliveryFeeNet,
                        deliveryFeePercentage: itemDeliveryFeePercentage,
                        subtotal: itemTotal,
                        total: entryTotal,
                        unitCost: this.Util.RoundFloat(entryTotal / itemQuantity),
                        unit: this.view == 'INVENTORY' && this.inventory[item.item] && this.inventory[item.item].unit ? this.inventory[item.item].unit : null
                    });

                }

                var discountGlobal = 0;
                var discountGlobalPercentage = isNaN(this.modalInvoice.discount) ? 0 : this.modalInvoice.discount;
                if(discountGlobalPercentage >= 0)
                    discountGlobal = (discountGlobalPercentage / 100) * subtotal;
                else
                    discountGlobal = -discountGlobalPercentage;

                subtotal-= (discountGlobal + discount);
                let discountIva = discountGlobal*0.19;
                iva -= discountIva;
                let datadata = {
                    number: this.modalInvoice.number,
                    date: this.modalInvoice.date,
                    provider: {
                        has_rut : this.modalInvoice.provider.has_rut,
                        rut: this.modalInvoice.provider.rut,
                        name: this.modalInvoice.provider.name
                    },
                    items: items,
                    total: {
                        subtotal: subtotal,
                        iva: iva,
                        taxes: taxes,
                        discount: discount,
                        discountGlobal: discountGlobal,
                        deliveryFee: deliveryFeeNet,
                        total: subtotal + iva + taxes + deliveryFeeNet
                    },
                    files: this.modalInvoice.files,
                    pay_method: this.modalInvoice.pending ? 'PENDING_PAYMENT' : this.modalInvoice.pay_method,
                    comment: this.modalInvoice.comment,
                    view : this.modalInvoice.view,
                    is_invoice : this.modalInvoice.is_invoice,
                    expense_turn : !!this.modalInvoice.expense_turn
                };
                return datadata
            },
            invoiceItemsSelector() {
                let data = null
                if(this.view == 'INVENTORY') data = this.inventory;
                else if(this.view == 'EXPENSES') data = this.expenses;
                return this.Util.InventorySelectItems(data);
            },
            canExpenseTurn() {
                return this.Turn && (this.Auth.role.indexOf('admin') > -1 || (this.Auth.restrictions && this.Auth.restrictions.enable_expense_turn));
            }
        },
        watch: {
            'modalInvoice.expense_turn'(val) {
                if (!this.modalInvoice) return;
                if (!this.canExpenseTurn) return;
                localStorage.setItem('expenseTurn', !!val);
            }
        }
    }
</script>